var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38376 1.71872C4.53997 1.56251 4.79324 1.56251 4.94944 1.71872L6.94944 3.71872C7.10565 3.87493 7.10565 4.1282 6.94944 4.28441C6.79323 4.44061 6.53997 4.44061 6.38376 4.28441L5.0666 2.96725V14.0016C5.0666 14.2225 4.88752 14.4016 4.6666 14.4016C4.44569 14.4016 4.2666 14.2225 4.2666 14.0016V2.96725L2.94944 4.28441C2.79323 4.44061 2.53997 4.44061 2.38376 4.28441C2.22755 4.1282 2.22755 3.87493 2.38376 3.71872L4.38376 1.71872ZM11.3333 1.60156C11.5542 1.60156 11.7333 1.78065 11.7333 2.00156V13.0359L13.0504 11.7187C13.2066 11.5625 13.4599 11.5625 13.6161 11.7187C13.7723 11.8749 13.7723 12.1282 13.6161 12.2844L11.6161 14.2844C11.4599 14.4406 11.2066 14.4406 11.0504 14.2844L9.05043 12.2844C8.89422 12.1282 8.89422 11.8749 9.05043 11.7187C9.20664 11.5625 9.4599 11.5625 9.61611 11.7187L10.9333 13.0359V2.00156C10.9333 1.78065 11.1124 1.60156 11.3333 1.60156Z",
    fill: "#B4B6B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortGray);
export default __webpack_public_path__ + "static/media/sort-gray.4c77c5804ef470167ccba56f89ac2878.svg";
export { ForwardRef as ReactComponent };